import VueI18n from "vue-i18n";
import Vue from "vue";
import zh from "@/locales/zh.json";
import en from "@/locales/en.json";
import elementZhCN from "element-ui/lib/locale/lang/zh-CN";
import elementEn from "element-ui/lib/locale/lang/en";

Vue.use(VueI18n);

// 从 localStorage 获取语言设置，默认使用 en_US
const getLocale = () => {
  try {
    return localStorage.getItem("lang") || "en_US";
  } catch (e) {
    return "en_US";
  }
};

const i18n = new VueI18n({
  locale: getLocale(), // 语言标识
  fallbackLocale: "en_US", // 默认语言
  messages: {
    zh_CN: { ...zh, ...elementZhCN }, // 中文语言包（含 Element UI 内置文案）
    en_US: { ...en, ...elementEn } // 英文语言包（含 Element UI 内置文案）
  }
});

export default i18n;
